/*
 * Author: Chao.Wang
 * File Created: Monday, 25-01-06 07:44 pm
 * Last Modified: Tuesday, 25-01-07 10:07 pm, by Chao.Wang
 */

import { styled, Typography } from '@mui/material';

export const StyledDialogTitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 500,
  color: '#FFF',
  lineHeight: '24px',
  marginBottom: '12px',
  textAlign: 'center',
}));

export const StyledContent = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 400,
  color: '#9EA8B6',
  marginBottom: '24px',
  lineHeight: '22px',
  padding: '0 20px',
  textAlign: 'center',
}));

export const StyledConfirmText = styled(Typography)(() => ({
  fontSize: '10px',
  fontWeight: 400,
  color: '#9EA8B66',
  lineHeight: '16px',
}));
